module.exports = __webpack_public_path__ + "img/Quest.cd187083.png";